import { ChartData, ChartDataset, ChartOptions } from 'chart.js'
import React from 'react'
import { ChartProps, Bar } from 'react-chartjs-2'

import { GraphData } from 'src/api/gen'
import { getDefaultOptions } from 'src/commons/graphs/graphCommons'

import { truncateLabel } from './helpers'

const Y_AXIS_LABEL_WIDTH = 20 // in characters (letters)

interface IGraphProps {
  datasets: GraphData['datasets']
  displayLegend: boolean
  enableAnimation?: boolean
  labels: GraphData['labels']
  showTitle?: boolean
  title?: string
}

const HorizontalHistogram = (props: IGraphProps) => {
  const datasets: ChartDataset<'bar'>[] = props.datasets.map((dataset) => {
    return {
      label: dataset.label,
      data: dataset.data,
      borderWidth: 1,
      backgroundColor: 'rgba(30,144,255,0.2)',
      borderColor: 'rgba(30,144,255,1)',
    }
  })

  const data: ChartData<'bar'> = {
    labels: props.labels.map((label: string) => truncateLabel(label, Y_AXIS_LABEL_WIDTH)),
    datasets,
  }

  const filledProps = { enableAnimation: true, ...props }

  const options: ChartProps['options'] = {
    ...getDefaultOptions({
      showTitle: props.showTitle,
      title: props.title,
      displayLegend: filledProps.displayLegend,
      enableAnimation: filledProps.enableAnimation,
    }),
    indexAxis: 'y',
  }

  Object.assign(options, {
    scales: {
      x: {
        beginAtZero: true,
      },
    },
  })

  return <Bar data={data} options={options as ChartOptions<'bar'>} />
}

export default HorizontalHistogram
